import { InMemoryDbService } from 'angular-in-memory-web-api';

export class InMemoryMenuService implements InMemoryDbService {
  createDb() {
      const menus = [
        {
          'id': 1,
          'name': 'WELCOME',
          'path': '/welcome',
          'iconClass': 'icon-welcome',
          'order': 1,
          'isMaterialIcon': false
        },
        {
          'id': 2,
          'name': 'DASHBOARD',
          'path': '/dashboard',
          'iconClass': 'icon-dashboard',
          'order': 1,
          'isMaterialIcon': false
        }
      ];
      const otherRoutes = [{
        'id': 2,
        'name': 'Settings',
        'path': '/settings',
      }];
    return { menus, otherRoutes};
  }
}

